import React, {FC, useCallback, useState} from 'react'

/** Liste ekranlarında toplu seçim; sayfa değişse de seçim korunur */
export function useSelection() {
  const [selectedIds, setSelectedIds] = useState<string[]>([])

  const toggle = useCallback(
    (id: string) => setSelectedIds((ids) => (ids.includes(id) ? ids.filter((item) => item !== id) : [...ids, id])),
    []
  )

  /** Sayfadaki kayıtların hepsi seçiliyse kaldırır, değilse hepsini ekler */
  const togglePage = useCallback(
    (pageIds: string[]) =>
      setSelectedIds((ids) =>
        pageIds.every((id) => ids.includes(id))
          ? ids.filter((id) => !pageIds.includes(id))
          : Array.from(new Set([...ids, ...pageIds]))
      ),
    []
  )

  const clear = useCallback(() => setSelectedIds([]), [])

  return {selectedIds, toggle, togglePage, clear}
}

/** Tablo satırındaki seçim kutusu */
export const SelectCheckbox: FC<{checked: boolean; onChange: () => void; disabled?: boolean}> = ({
  checked,
  onChange,
  disabled,
}) => (
  <div className='form-check form-check-sm form-check-custom form-check-solid'>
    <input
      type='checkbox'
      className='form-check-input'
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      onClick={(event) => event.stopPropagation()}
    />
  </div>
)

type ToolbarProps = {
  pageIds: string[]
  selectedIds: string[]
  onTogglePage: (pageIds: string[]) => void
  onClear: () => void
  onTransfer: () => void
}

/** "Sayfadakileri seç" + seçilenleri arama havuzuna aktarma */
export const SelectionToolbar: FC<ToolbarProps> = ({pageIds, selectedIds, onTogglePage, onClear, onTransfer}) => {
  const allSelected = pageIds.length > 0 && pageIds.every((id) => selectedIds.includes(id))
  return (
    <div className='d-flex flex-wrap align-items-center gap-4 mb-4'>
      <label className='form-check form-check-sm form-check-custom form-check-solid'>
        <input
          type='checkbox'
          className='form-check-input'
          checked={allSelected}
          disabled={pageIds.length === 0}
          onChange={() => onTogglePage(pageIds)}
        />
        <span className='form-check-label text-gray-700'>Sayfadakileri seç</span>
      </label>
      {selectedIds.length > 0 && (
        <>
          <span className='text-muted fs-7'>{selectedIds.length} kayıt seçili</span>
          <button type='button' className='btn btn-sm btn-success' onClick={onTransfer}>
            <i className='bi bi-telephone-plus'></i>
            Arama Havuzuna Aktar ({selectedIds.length})
          </button>
          <button type='button' className='btn btn-sm btn-light' onClick={onClear}>
            Seçimi Temizle
          </button>
        </>
      )}
    </div>
  )
}
